import React, { createContext, useContext } from 'react';
import dateFnslocale from 'date-fns/locale/en-US';

import { BrandProvider } from './BrandProvider';
import CurrencyLocaleContext from './CurrencyLocaleContext';
import { ThemeProvider } from './ThemeProvider';
import { VersionProvider } from './VersionProvider';

const DateFnsContext = createContext(dateFnslocale);

export const useCurrencyLocale = () => useContext(CurrencyLocaleContext);
export const useDateFns = () => useContext(DateFnsContext);

const PrismaProvider = ({
  brand = 'ED',
  version,
  currencyLocale = { locale: 'en' },
  dateFnsLocale,
  children,
}) => {
  return (
    <BrandProvider brand={brand}>
      <VersionProvider version={version}>
        <CurrencyLocaleContext.Provider value={currencyLocale}>
          <DateFnsContext.Provider value={dateFnsLocale}>
            <ThemeProvider>{children}</ThemeProvider>
          </DateFnsContext.Provider>
        </CurrencyLocaleContext.Provider>
      </VersionProvider>
    </BrandProvider>
  );
};

export default PrismaProvider;
